<!-- Me parece que este no se uso al final  -->
<template>
    <div class="max-w-6xl mx-auto p-6 bg-white">
        <!-- Header -->
        <h1 class="text-2xl font-semibold text-gray-900 mb-8">Importar imágenes (ZIP)</h1>

        <!-- Step Indicator -->
        <div class="flex items-center justify-between mb-8">
            <div v-for="s in steps" :key="s.number" class="flex items-center" :class="{ 'flex-1': s.number < 4 }">
                <div class="flex items-center">
                    <div class="flex items-center justify-center w-8 h-8 rounded-full text-white text-sm font-medium"
                        :class="stepCircleClass(s.number)">
                        {{ s.number }}
                    </div>
                    <span class="ml-3 text-sm font-medium" :class="stepTextClass(s.number)">
                        {{ s.title }}
                    </span>
                </div>
                <div v-if="s.number < 4" class="flex-1 h-px mx-4" :class="connectorClass(s.number)"></div>
            </div>
        </div>

        <!-- Content Area -->
        <div class="bg-white border border-gray-200 rounded-lg">
            <!-- Step 1: Upload ZIP + mode -->
            <div v-if="currentStep === 1" class="p-6 space-y-6">
                <div>
                    <h2 class="text-lg font-medium text-gray-900 mb-2">Modo de identificación</h2>
                    <!-- Radio Button Options -->
                    <div class="space-y-4 mb-8">
                        <label class="flex items-center cursor-pointer">
                            <input type="radio" v-model="namingMode" value="name"
                                class="w-4 h-4 border-gray-300 focus:ring-blue-500" />
                            <span class="ml-3 text-gray-700">Nombre del residente</span>
                        </label>

                        <label class="flex items-center cursor-pointer">
                            <input type="radio" v-model="namingMode" value="phone"
                                class="w-4 h-4 border-gray-300 focus:ring-blue-500" />
                            <span class="ml-3 text-gray-700">Número de teléfono</span>
                        </label>
                    </div>


                </div>

                <div class="border-2 border-dashed rounded-lg p-8 text-center"
                    :class="{ 'border-gray-300': !hasErrors, 'border-red-400': hasErrors }">
                    <p class="text-gray-500">Carga un archivo .zip que contenga las imágenes.</p>
                    <input ref="fileInput" type="file" accept=".zip" class="hidden" @change="onZipSelected" />
                    <button class="mt-4 px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600"
                        @click="$refs.fileInput.click()">
                        Seleccionar ZIP
                    </button>
                    <p v-if="fileName" class="mt-3 text-sm text-gray-600">
                        Seleccionado: <strong>{{ fileName }}</strong>
                    </p>
                    <p v-if="zipStats.total > 0" class="mt-2 text-sm text-gray-600">
                        Archivos detectados: <strong>{{ zipStats.images }}</strong> imágenes de {{ zipStats.total }}
                        totales
                    </p>
                </div>

                <div v-if="hasErrors && currentStep === 1"
                    class="p-3 rounded border border-red-300 bg-red-50 text-sm text-red-700">
                    <p class="font-medium mb-1">Corrige antes de continuar:</p>
                    <ul class="list-disc ml-6">
                        <li v-for="(err, i) in validationErrors" :key="i">{{ err }}</li>
                    </ul>
                </div>
            </div>

            <!-- Step 2: Data Loading / Review -->
            <div v-if="currentStep === 2" class="p-6">
                <div class="flex items-center justify-between mb-6">
                    <h2 class="text-lg font-medium text-gray-900">
                        Imágenes procesadas ({{ records.length }} registros)
                    </h2>
                </div>

                <div class="overflow-hidden border border-gray-200 rounded-lg">
                    <table class="min-w-full divide-y divide-gray-200">
                        <thead class="bg-gray-50">
                            <tr>
                                <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Archivo</th>
                                <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Nombre</th>
                                <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Teléfono
                                </th>
                                <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Acciones
                                </th>
                            </tr>
                        </thead>
                        <tbody class="bg-white divide-y divide-gray-200">
                            <tr v-for="record in records" :key="record.id" class="hover:bg-gray-50">
                                <td class="px-6 py-2 text-sm text-gray-700">
                                    {{ record.filename }}
                                </td>
                                <td class="px-6 py-2 text-sm">
                                    <input v-model.trim="record.name"
                                        class="w-full border border-gray-300 rounded px-2 py-1 focus:outline-none focus:ring" />
                                </td>
                                <td class="px-6 py-2 text-sm">
                                    <input v-model.trim="record.phone"
                                        class="w-full border border-gray-300 rounded px-2 py-1 focus:outline-none focus:ring" />
                                </td>
                                <td class="px-6 py-2 text-sm">
                                    <button class="px-2 py-1 text-red-500 hover:text-red-700"
                                        @click="onDelete(record.id)">Eliminar</button>
                                </td>
                            </tr>
                            <tr v-if="records.length === 0">
                                <td colspan="4" class="px-6 py-6 text-center text-sm text-gray-500">Sin datos cargados.
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div v-if="hasErrors && currentStep === 2"
                    class="mt-4 p-3 rounded border border-red-300 bg-red-50 text-sm text-red-700">
                    <p class="font-medium mb-1">Corrige los siguientes errores:</p>
                    <ul class="list-disc ml-6">
                        <li v-for="(err, i) in validationErrors" :key="i">{{ err }}</li>
                    </ul>
                </div>
            </div>

            <!-- Step 3: Validation summary -->
            <div v-if="currentStep === 3" class="p-6">
                <h2 class="text-lg font-medium text-gray-900 mb-4">Validación de datos</h2>
                <div class="space-y-4">
                    <div class="flex items-center p-4 bg-green-50 border border-green-200 rounded-md">
                        <svg class="w-5 h-5 text-green-500 mr-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
                        </svg>
                        <span class="text-green-800">Todos los registros son válidos</span>
                    </div>
                    <p class="text-gray-600">Se han validado {{ records.length }} registros correctamente.</p>
                </div>
            </div>

            <!-- Step 4: Finish -->
            <div v-if="currentStep === 4" class="p-6">
                <h2 class="text-lg font-medium text-gray-900 mb-4">Finalizar carga</h2>
                <div class="text-center py-8">
                    <svg class="w-16 h-16 text-green-500 mx-auto mb-4" fill="none" stroke="currentColor"
                        viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
                    </svg>
                    <h3 class="text-lg font-medium text-gray-900 mb-2">¡Importación completada!</h3>
                    <p class="text-gray-600">Se han preparado {{ records.length }} imágenes para procesar.</p>
                </div>
            </div>
        </div>

        <!-- Navigation Buttons -->
        <div class="flex justify-between mt-8">
            <button v-if="currentStep > 1" @click="goToPreviousStep"
                class="px-6 py-2 border border-gray-300 text-gray-700 rounded-md hover:bg-gray-50">
                Anterior
            </button>
            <div v-else></div>

            <button @click="goToNextStep"
                class="px-6 py-2 rounded-md text-white disabled:opacity-50 disabled:cursor-not-allowed"
                :class="nextButtonClass" :disabled="false">
                {{ currentStep === 4 ? 'Finalizar' : 'Siguiente' }}
            </button>
        </div>
    </div>
</template>

<script>
import JSZip from 'jszip'

export default {
    name: 'MassiveFacialLoad',
    data() {
        return {
            currentStep: 1,
            fileName: '',
            namingMode: 'name', // 'name' | 'phone'
            records: [],
            zipStats: { total: 0, images: 0 },
            stepState: { 1: 'current', 2: 'pending', 3: 'pending', 4: 'pending' },
            validationErrors: []
        }
    },
    computed: {
        steps() {
            return [
                { number: 1, title: 'Configurar & Subir ZIP' },
                { number: 2, title: 'Revisión de datos' },
                { number: 3, title: 'Validación de datos' },
                { number: 4, title: 'Finalizar' }
            ]
        },
        hasErrors() {
            return this.validationErrors.length > 0
        },
        nextButtonClass() {
            return this.hasErrors
                ? 'bg-gray-400'
                : (this.currentStep === 4 ? 'bg-green-600 hover:bg-green-700' : 'bg-blue-700 hover:bg-blue-500')
        }
    },
    methods: {
        // =================== ZIP ===================
        async onZipSelected(e) {
            const file = e.target.files && e.target.files[0]
            if (!file) return

            this.fileName = file.name
            this.validationErrors = []
            this.zipStats = { total: 0, images: 0 }
            this.records = []

            try {
                // 1) Cargar el ZIP
                const zip = await JSZip.loadAsync(file)

                // 2) Listar archivos
                const allFiles = Object.keys(zip.files)
                this.zipStats.total = allFiles.length

                // 3) Filtrar: no dirs, no __MACOSX, no '._', solo imágenes
                const imageEntries = allFiles
                    .filter(path => !zip.files[path].dir)
                    .filter(path => !path.startsWith('__MACOSX/'))
                    .filter(path => this.isImage(path))
                    .filter(path => !this.basename(path).startsWith('._'))

                this.zipStats.images = imageEntries.length

                // 4) Evitar duplicados por "stem" (nombre sin extensión)
                const seenStems = new Set()
                const rows = []
                imageEntries.forEach((path, idx) => {
                    const base = this.basename(path)              // e.g. "1122443322.png"
                    const stem = base.replace(/\.[^.]+$/, '')     // "1122443322"
                    if (seenStems.has(stem)) return
                    seenStems.add(stem)

                    const phone = this.normalizePhone(stem)
                    rows.push({
                        id: Date.now() + idx,
                        filename: base,
                        name: this.namingMode === 'name' ? stem : '',
                        phone: this.namingMode === 'phone' ? phone : '',
                        previewUrl: '' // si luego generas miniaturas
                    })
                })

                this.records = rows

                // await this.generatePreviews(zip, imageEntries, this.records)

                this.stepState[1] = 'done'
                this.currentStep = 2
                this.stepState[2] = 'current'
            } catch (err) {
                console.error('ZIP error:', err)
                this.validationErrors = ['No se pudo leer el ZIP. Verifica el archivo.']
                this.stepState[1] = 'error'
            } finally {
                // Limpia el input para permitir recargar el mismo archivo si quieres
                if (this.$refs.fileInput) this.$refs.fileInput.value = ''
            }
        },
        isImage(path) {
            return /\.(jpe?g|png|webp|bmp|gif)$/i.test(path)
        },
        basename(path) {
            return path.split('/').pop()
        },
        normalizePhone(str) {
            // Deja solo dígitos, útil si el nombre es "52-81-1234-5678"
            return (str || '').replace(/\D+/g, '')
        },

        // =================== Navegación ===================
        goToNextStep() {
            if (this.currentStep >= 4) return
            const { ok, errors } = this.validateStep(this.currentStep)
            this.validationErrors = errors
            if (!ok) {
                this.stepState[this.currentStep] = 'error'
                return
            }
            this.stepState[this.currentStep] = 'done'
            this.currentStep += 1
            this.stepState[this.currentStep] = 'current'
            this.validationErrors = []
        },
        goToPreviousStep() {
            if (this.currentStep === 1) return
            if (this.stepState[this.currentStep] !== 'done') {
                this.stepState[this.currentStep] = 'pending'
            }
            this.currentStep -= 1
            this.stepState[this.currentStep] = 'current'
            this.validationErrors = []
        },

        // =================== Validación por paso ===================
        validateStep(n) {
            switch (n) {
                case 1: return this.validateStep1()
                case 2: return this.validateStep2()
                case 3: return this.validateStep3()
                default: return { ok: true, errors: [] }
            }
        },
        validateStep1() {
            const errors = []
            if (!this.fileName) errors.push('Selecciona un archivo ZIP.')
            if (!['name', 'phone'].includes(this.namingMode)) errors.push('Selecciona el modo de identificación.')
            if (this.records.length === 0) errors.push('El ZIP no contiene imágenes válidas.')
            return { ok: errors.length === 0, errors }
        },
        validateStep2() {
            const errors = []
            if (this.records.length === 0) {
                errors.push('No hay registros generados.')
                return { ok: false, errors }
            }

            // Reglas por modo
            if (this.namingMode === 'name') {
                // nombre requerido; teléfono opcional (si lo editas)
                this.records.forEach((r, i) => {
                    if (!r.name) errors.push(`Fila ${i + 1}: el nombre es requerido (modo "Nombre").`)
                })
            } else {
                // phone requerido y numérico
                const seen = new Set()
                this.records.forEach((r, i) => {
                    const p = (r.phone || '').trim()
                    if (!p) {
                        errors.push(`Fila ${i + 1}: el teléfono es requerido (modo "Teléfono").`)
                    } else if (!/^\d{7,15}$/.test(p)) {
                        errors.push(`Fila ${i + 1}: el teléfono "${p}" no es válido. Usa sólo dígitos (7-15).`)
                    } else {
                        const k = p
                        if (seen.has(k)) errors.push(`Duplicado: el teléfono "${p}" se repite.`)
                        seen.add(k)
                    }
                })
            }

            return { ok: errors.length === 0, errors }
        },
        validateStep3() {
            // Aquí podrías hacer validaciones extra (contra backend, etc.)
            return { ok: true, errors: [] }
        },

        // =================== Tabla ediciones ===================
        onDelete(id) {
            this.records = this.records.filter(r => r.id !== id)
        },

        // =================== UI helpers ===================
        stepCircleClass(n) {
            const st = this.stepState[n]
            if (st === 'done') return 'bg-green-600'
            if (st === 'current') return 'bg-blue-600'
            if (st === 'error') return 'bg-red-500'
            return 'bg-gray-300'
        },
        stepTextClass(n) {
            const st = this.stepState[n]
            if (st === 'done') return 'text-green-700'
            if (st === 'current') return 'text-gray-900'
            if (st === 'error') return 'text-red-600'
            return 'text-gray-400'
        },
        connectorClass(n) {
            return this.stepState[n] === 'done' ? 'bg-green-400' : 'bg-gray-300'
        }
    }
}
</script>

<style scoped>
/* Colorea el radio nativo (browsers modernos) */
input[type="radio"] {
    accent-color: #3b82f6;
}

/* Texto del label más notorio cuando está checked */
input[type="radio"]:checked+span {
    color: #111827;
    /* text-gray-900 */
    font-weight: 600;
    /* semibold */
}


/* helpers hover */
.hover\:bg-gray-50:hover {
    background-color: #f9fafb;
}

.hover\:bg-blue-600:hover {
    background-color: #2563eb;
}

.hover\:bg-gray-800:hover {
    background-color: #1f2937;
}

.hover\:text-gray-600:hover {
    color: #4b5563;
}

.hover\:text-red-600:hover {
    color: #dc2626;
}
</style>
